import { optional, array, obj, required } from 'AppReact/schema';

export const assignment = {
  category: required('string'),
  id: required('number'),
  property: required('string'),
  property_icon: optional('string'),
  parent_category: optional('string'),
  rating: optional('number'),
  assigned_at: required('jsDate'),
  completed_at: required('jsDate'),
  status: required('string'),
  tenant: optional('string'),
  unit: optional('string'),
}

export const assignmentsGroup = {
  label: optional('string'),
  assignments: array(obj(assignment)),
  date: optional('jsDate'),
}